import { render, staticRenderFns } from "./UserCenterNew.vue?vue&type=template&id=4d7ea01c&scoped=true"
import script from "./UserCenterNew.vue?vue&type=script&lang=js"
export * from "./UserCenterNew.vue?vue&type=script&lang=js"
import style0 from "./UserCenterNew.vue?vue&type=style&index=0&id=4d7ea01c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ea01c",
  null
  
)

export default component.exports